<div class="add-container">
    <h1 class="add-title">Adaugă program</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Modul</mat-label>
                    <mat-select formControlName="modul_id" (openedChange)="onModulSelectClosed()">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="moduleControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredModule.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let modul of filteredModule" [value]="modul.id">
                            {{ modul.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['modul_id'].valid && form.controls['modul_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Locație</mat-label>
                    <mat-select (openedChange)="onLocatieSelectClosed()" formControlName="locatie_id">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="locatiiControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredLocatii.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let locatie of filteredLocatii" [value]="locatie.id">
                            {{ locatie.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['locatie_id'].valid && form.controls['locatie_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Specializare</mat-label>
                    <mat-select formControlName="specializare_id" (openedChange)="onSpecializareSelectClosed()">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="specializariControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredSpecializari.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let specializare of filteredSpecializari" [value]="specializare.id">
                            {{ specializare.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['specializare_id'].valid && form.controls['specializare_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Specialist</mat-label>
                    <mat-select (openedChange)="onOperatoriSelectClosed()"
                        (selectionChange)="onOperatorChange($event.value)" formControlName="specialist_id">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="operatoriControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredOperatori.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let operator of filteredOperatori" [value]="operator.id_user">
                            {{ operator.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="!form.controls['specialist_id'].valid && form.controls['specialist_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Tip problemă</mat-label>
                    <mat-select (openedChange)="onTipProblemaSelectClosed()" formControlName="tip_problema_id">
                        <mat-form-field class="px-2 w-100 sticky-input">
                            <input matInput [formControl]="tipuriProblemeControl" (keydown)="$event.stopPropagation()"
                                (click)="$event.stopPropagation()" />
                        </mat-form-field>

                        <mat-option *ngIf="filteredTipuriProbleme.length === 0" disabled>
                            <span>No results found</span>
                        </mat-option>

                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                        <mat-option *ngFor="let tipProblema of filteredTipuriProbleme" [value]="tipProblema.id">
                            {{ tipProblema.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['tip_problema_id'].valid && form.controls['tip_problema_id'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>